import styled from 'styled-components'

export const StatisticWrapper = styled.div`
  flex: ${(props) => (props.theme.isMobile ? '1' : '0')};
  padding: ${(props) => (props.theme.isMobile ? '0.5rem' : '1.5rem')};
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.gradient.cardBackground};
  box-shadow: ${(props) => props.theme.shadow.main};
  border-radius: 6px;
  color: white;
`
export const CenterWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0.5rem;
`
export const ValueWrapper = styled.div`
  flex: 1;
  padding: ${(props) => (props.theme.isMobile ? '0.5rem 0' : '0.5rem')};
  display: flex;
  flex-direction: row;
  font-size: ${(props) => (props.theme.isMobile ? '1.5rem' : '3rem')};
  font-weight: 700;
  align-items: baseline;
  & svg {
    margin: 0 auto;
    font-size: 1.5rem;
    align-self: center;
  }
`
export const Title = styled.div`
  display: flex;
  font-size: ${(props) => (props.theme.isMobile ? '0.8rem' : '1rem')};
  white-space: nowrap;
  justify-content: space-between;
`
export const InfoMessage = styled.div`
  display: inline-block;
  padding-left: 1rem;
`
export const UnitsSpan = styled.span`
  font-size: ${(props) => (props.theme.isMobile ? '0.7rem' : '0.9rem')};
  font-weight: 500;
  padding: 0 0.5rem;
`
